import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _3gMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"3g_mobiledata"}/>
}
